module.exports = __webpack_public_path__ + "img/sddefault.24c235ce.jpg";